import axios from 'axios';
import { API_ORIGIN } from '../config';
import { attachAuthInterceptors } from './authTokenRefresh';

export const axiosInstance = axios.create({
  baseURL: API_ORIGIN,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

attachAuthInterceptors(axiosInstance);
